import { render, staticRenderFns } from "./DEXTRPanel.vue?vue&type=template&id=16376142&"
import script from "./DEXTRPanel.vue?vue&type=script&lang=js&"
export * from "./DEXTRPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports